"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
exports.validateSubForm = function (key, subFormFormikProps) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var fieldKeys, errorFields, isValid;
    var _a;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                fieldKeys = Object.keys(subFormFormikProps.values[key]);
                return [4 /*yield*/, subFormFormikProps.setTouched((_a = {},
                        _a[key] = tslib_1.__assign({}, fieldKeys.reduce(function (acc, keyName) {
                            var _a;
                            return (tslib_1.__assign(tslib_1.__assign({}, acc), (_a = {}, _a[keyName] = true, _a)));
                        }, {})),
                        _a))];
            case 1:
                _b.sent();
                return [4 /*yield*/, subFormFormikProps.validateForm(subFormFormikProps.values)];
            case 2:
                errorFields = _b.sent();
                isValid = Object.keys(errorFields).length === 0;
                return [2 /*return*/, {
                        isValid: isValid,
                        errorFieldIds: isValid ? [] : Object.keys(errorFields[key]).map(function (field) { return key + "." + field; })
                    }];
        }
    });
}); };
//# sourceMappingURL=validateSubForm.js.map